export const VDP_RUN_DETAILS_SET='VDP_RUN_DETAILS_SET';


// WEBPACK FOOTER //
// ./src/redux/vdpRuns/actionTypes.js